<ev-dialog
    [visible]="true"
    [title]="'Abonner på ukesrapport'"
    [theme]="'green'"
    [showConfirmLoader]="showLoader()"
    [disabledConfirm]="processing || (!readyToClose && hasError())"
    [hideCancel]="readyToClose"
    [confirmText]="readyToClose ? 'Lukk' : 'Abonner'"
    [cancelText]="'Avbryt'"
    (close)="closeWizard()"
    (confirm)="confirmReport()"
    [useBorderRadius]="!isMobileView"
>
<div class="main-subscription-wizard-wrapper">
        @if (!readyToClose && !processing) {
        <div class="subscription-wizard-wrapper">
            <div class="row">
                <div class="header">Tittel på rapport</div>
                <div class="content">
                    <div class="input-wrapper">
                    <input type="text" [formField]="this.subscriptionReportForm.reportTitle" />
                    <div class="cancelInput align-right"></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="header">Din e-postadresse</div>
                <div class="recipients-wrapper">
                    <div class="main-recipient">
                        <div class="input-area">
                            <div class="input-wrapper">
                            <input type="text" [formField]="this.subscriptionReportForm.recipients[0].recipient" />
                            <div class="cancelInput align-right"></div>
                            </div>
                        </div>
                    </div>
                    @if (!addMoreIsOpen) {
                    <div class="add-more-recipients">
                        <p class="add-link" (click)="openAddMoreRecipients()">Legg til flere mottakere av denne rapporten</p>
                    </div>
                    } @if (addMoreIsOpen) { @for (recipient of this.subscriptionReportForm.recipients().value() | slice : 1; track $index; let i = $index){
                    <div class="more-recipients">
                        <div class="email">
                            <div class="input-wrapper">
                            <input type="text" [formField]="this.subscriptionReportForm.recipients[i + 1].recipient" />
                            <div class="cancelInput align-right"></div>                           
                            </div>
                        </div>
                        <div class="trash">
                            <div class="icon" (click)="removeRecipient(i + 1)"></div>
                        </div>
                    </div>
                    }
                    <div class="add-button" (click)="pushEmptyRecipient()">Legg til flere mottakere</div>
                    } @if (validationErrors().notValidEmails.length > 0) {
                    <div class="warning-wrapper">
                        <div class="warning">
                            <p>
                                Feil skrevet e-postadresse: {{ validationErrors().notValidEmails.join(", ") }}. Vennligst sjekk stavingen og prøv igjen.
                            </p>
                        </div>
                    </div>
                    } @if (validationErrors().notValidDomains.length > 0) {
                    <div class="warning-wrapper">
                        <div class="warning">
                            <p>
                                @if (validationErrors().notValidDomains.length === 1) {
                                Domenet {{ notValidDomainsText() }} i e-postadressen er ikke godkjent for denne brukertilgangen.
                                } @else {
                                Domenene {{ notValidDomainsText() }} i e-postadressene er ikke godkjent for denne brukertilgangen.
                                }
                                Skulle dette være feil, eller det er flere domener registrert under deres selskap, kontakt oss på tlf: {{ support.phone }} eller e-post:
                                <a [href]="'mailto:' + support.email">{{ support.email }}</a>.
                            </p>
                        </div>
                    </div>
                    }
                </div>
            </div>
            <div class="row">
                <div class="header">Dag for utsendelse</div>
                <div class="calendar-wrapper desktop">
                    @for (number of weekArray; track number) {
                    <div class="container" (click)="setDay(number)">
                        <div class="calendar-card" [ngClass]="{ active: number === currentDayIdx }">{{ days[number][0] }}</div>
                        <div class="radio">
                            <input type="radio" id="day_1" name="day" value="1" [checked]="number === currentDayIdx" />
                        </div>
                    </div>
                    }
                </div>
                <div class="calendar-wrapper mobile custom-select">
                    <div class="dropdown-wrapper">
                        <div (click)="toggleDayDropDown()" class="dropbtn">{{ currentDayText }}</div>
                        <div class="dropdown-content" [ngClass]="{ show: ddOpen }">
                            @for (number of weekArray; track number){
                            <div class="dropdown-item" [ngClass]="{ selected: number === currentDayIdx }" (click)="selectDay(number)">
                                {{ days[number][1] }}
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
        } @if (processing) {
        <div class="subscription-wizard-wrapper center fixed-height">
            <div class="row center">
                <ev-logo-loader width="70px" />
            </div>
        </div>
        } @if (this.readyToClose && triggerSubscriptionSuccess && !processing) {
        <div class="subscription-wizard-wrapper fixed-height">
            <div class="row">
                <div class="success-icon"></div>
            </div>
            <div class="row">
                <div class="header center large">Ukesrapport opprettet!</div>
            </div>
            <div class="row">
                <div>Vi har sendt deg en e-post med rapport for siste uke. Alle kommende rapporter vil bli sendt ut på den ukedagen du har valgt.</div>
            </div>
        </div>
        } @if (this.readyToClose && !triggerSubscriptionSuccess && !processing) {
        <div class="subscription-wizard-wrapper fixed-height">
            <div class="row">
                <div class="fail-icon"></div>
            </div>
            <div class="row">
                <div class="header center large">Ojsann!</div>
            </div>
            <div class="row">
                <div>
                    En feil har oppstått og abonnementet ble dessverre ikke opprettet. Vennligst vent litt og prøv igjen. For support, kontakt
                    <a [href]="'mailto:' + support.email">{{ support.email }}</a>
                    eller ring {{ support.phone }}
                </div>
            </div>
        </div>
        } @if (!readyToClose && !processing) {
        <ng-container>
            <div class="more-info-wrapper">
                <div class="more-info-accordion">
                    <div class="header" (click)="infoToggleOpen = !infoToggleOpen">
                        <div class="text">Grunnlag for rapport</div>
                        <div class="icon" [class.is-open]="infoToggleOpen"></div>
                    </div>
                    <div class="content" [class.is-open]="!infoToggleOpen">
                        <div class="card no-pad">
                            <div>
                                <subscription-selected-filters></subscription-selected-filters>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        }
    </div>
</ev-dialog>